<template>
    <div class="container">
        <div aria-atomic="true" v-if="showVote">
            <h1 ref="titleVote">{{ currentPage.title }}</h1>
            <p aria-hidden="true">Du skal nu svare</p>
            <choices :selectable="true"
                     class="choices"
                     v-bind:choices="choices"
                     v-bind:value="activeChoiceIndex"
                     v-on:value="activeChoiceIndex = $event; onClickAnswer();"/>
        </div>
        <div class="ready-screen" v-else>
            <div class="ready-circle"></div>
            <h1 ref="titleNoVote">Du er klar!</h1>
            <ready-hand/>
        </div>
    </div>
</template>

<script>
    import PagePhase from '@/enum/PagePhase'
    import {mapGetters} from 'vuex'
    import ReadyHand from '@/components/ready-hand'
    import AppButton from '@/components/app-button'
    import Choices from '@/components/choices'
    import ThingToHtml from '../../../../lib/ThingToHtmlVue/index.vue'
    import {getStudentUrl} from '@/utils/UrlUtil'
    import {focusReference} from '@/utils/UiUtil';

    export default {
        components: {
            ThingToHtml,
            Choices,
            ReadyHand,
            AppButton
        },
        data() {
            return {
                activeChoiceIndex: -1,
                sentVote: false
            }
        },
        watch: {
            currentPagePhase(currentPagePhase) {
                if (currentPagePhase === PagePhase.Result) {
                    // Reset sent vote
                    this.sentVote = false
                }
            },
            currentPage() {
                if (this.showVote) {
                    focusReference(this, 'titleVote');
                } else {
                    focusReference(this, 'titleNoVote');
                }
            }
        },
        computed: {
            ...mapGetters({
                currentCase: 'getCurrentCase',
                currentGamePhase: 'getCurrentGamePhase',
                currentPageIndex: 'getCurrentPageIndex',
                currentPagePhase: 'getCurrentPagePhase',
            }),
            currentPage() {
                if (!this.currentCase) {
                    return null;
                }

                if (this.currentCase.pages.length < this.currentPageIndex - 1) {
                    return null;
                }

                return this.currentCase.pages[this.currentPageIndex];
            },
            currentPageComponents() {
                if (!this.currentPage) {
                    return null;
                }

                if (!this.currentPage.components) {
                    return null;
                }

                return this.currentPage.components;
            },
            leftComponentType() {
                if (!this.currentPageComponents) {
                    return null;
                }

                if (!this.currentPageComponents.left) {
                    return null;
                }

                return this.currentPageComponents.left.component;
            },
            rightComponentType() {
                if (!this.currentPageComponents) {
                    return null;
                }

                if (!this.currentPageComponents.right) {
                    return null;
                }

                return this.currentPageComponents.right.component;
            },
            isChoiceComponent() {
                return this.leftComponentType === 'Choices' || this.rightComponentType === 'Choices';
            },
            choiceComponentOptions() {
                if (this.leftComponentType === 'Choices') {
                    return this.currentPageComponents.left.options;
                } else if (this.rightComponentType === 'Choices') {
                    return this.currentPageComponents.right.options;
                }

                return null;
            },
            showVote() {
                return this.isChoiceComponent && this.currentPagePhase === PagePhase.Normal && !this.sentVote;
            },
            choices() {
                if (!this.choiceComponentOptions) {
                    return [];
                }

                return this.choiceComponentOptions.choices;
            }
        },
        methods: {
            onClickAnswer() {
                if (this.sentVote) {
                    return
                }

                if (this.activeChoiceIndex < 0) {
                    return
                }

                this.$gameClient.send({
                    currentVote: this.activeChoiceIndex
                })

                this.sentVote = true
            }
        },
        mounted() {
            if (!this.$gameClient || !this.$gameClient.isConnected) {
                console.log('$gameClient was not connected to the server - going back to index')

                // The game is not at the right point right now.. let's revert the user to the connect screen
                this.$router.push(getStudentUrl('index'))

                return
            }

            if (!this.currentCase) {
                console.log('Could not find a current case - going back to index')

                this.$router.push(getStudentUrl('connect'))

                return
            }
        }
    }
</script>

<style lang="less" scoped>
    @import "~@less/mixins/mixins.less";

    .circle-radius(@browserWidth, @top) {
        @radius: @browserWidth * .7;

        border-radius: @radius;
        width: (@radius * 2);
        height: (@radius * 2);
        margin-left: -@radius;
        top: @top;
    }

    .ready-screen {
        h1 {
            font-size: 20pt;
            color: white;
        }

        .ready-hand {
            position: absolute;
            top: 20%;
            left: 50%;

            //width: 205px;
            //height: 194px;

            transform: translate(-50%, -30%);
        }
    }

    .answer-button-container {
        margin-top: 50px;
        text-align: center;
    }

    .ready-circle {
        background-color: #0E9512;
        position: fixed;
        left: 50%;
        z-index: -1;

        .circle-radius(500px, -260px);
    }

    .media-xs({ .ready-circle {
        .circle-radius(@width-xs, -364px);
    } });

    .media-sm({ .ready-circle {
        .circle-radius(@width-sm, -633px);
    } });

    .media-lg({ .ready-circle {
        .circle-radius(@width-lg, -1230px);
    } });

    .media-xl({ .ready-circle {
        .circle-radius(@width-xl, -1800px);
    } });

    .media-xxl({ .ready-circle {
        .circle-radius(@width-xxl, -2200px);
    } });
</style>